export default "__VITE_ASSET__99044194__"